const LIGHT_VARS = ':root{--color-ink:#FAFAFA;--color-inkMid:#FFFFFF;--color-inkSurface:#F0F0F5;--color-inkBorder:#D2D2D7;--color-inkMuted:#6E6E73;--color-inkSubtle:#3A3A3C;--color-inkText:#1D1D1F;--theme-document-background:#FAFAFA;--theme-document-color:#1D1D1F}'

const applyTheme = (isDark) => {
  let st = document.getElementById('__dm')
  if (!st) { st = document.createElement('style'); st.id = '__dm'; document.head.appendChild(st) }
  st.textContent = isDark ? '' : LIGHT_VARS
  localStorage.setItem('__dental_theme', isDark ? 'dark' : 'light')
}

export const ThemeToggle = {
  tag: 'button',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 'Y',
  round: 'Y',
  color: 'inkMuted',
  display: 'flex',
  align: 'center center',
  ':hover': { background: 'inkSurface', color: 'inkText' },
  show: (() => {
    let inited = false
    return (el, s) => {
      if (!inited) {
        inited = true
        const saved = localStorage.getItem('__dental_theme')
        if (saved === 'light') {
          Promise.resolve().then(() => { s.root.update({ darkMode: false }); applyTheme(false) })
        }
      }
      return true
    }
  })(),
  onClick: (e, el, s) => {
    const isDark = !s.root.darkMode
    s.root.update({ darkMode: isDark })
    applyTheme(isDark)
  },
  ThemeIcon: {
    extends: 'Icon',
    icon: (el, s) => s.root.darkMode ? 'sun' : 'moon',
    width: 'A',
    height: 'A'
  }
}
